<div *ngIf="loader.show">
  <div class="loader-box"></div>
  <div class="loader-block">
    <div class="row">
      <div class="col l12 m12 s12 center">
        <div class="processing-logo textLoader">
          <div class="logo">
            <img src="../../assets/images/loader-logo.svg" alt="" />
          </div>
        </div>
        <div class="reset-set">
          <div class="welcome-user">
            <div class="welcome-content">
              <h2 [innerHTML]="loader.text | safeHtml"></h2>
            </div>
            <div class="welcome-content timer" *ngIf="showTickingTimer && tickingTimerText && tickingTimerText.length > 0">
              <h2 [innerHTML]="tickingTimerText | safeHtml"></h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>